import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MsgConfig } from 'src/app/app.messages';
import { PharmacyLabels } from 'src/app/models/labels.models';
import { PatientInfoUtil } from 'src/app/utils/patient-info.util';
import { CommonUtil } from 'src/app/utils';
import { environment } from "src/environments/environment";
import { takeUntil } from 'rxjs/operators';
import { Subject } from "rxjs";
import { AlertService, CommonService } from 'src/app/services';

@Component({
  selector: 'app-pharmacy-selection',
  templateUrl: './pharmacy-selection.component.html',
  styleUrls: ['./pharmacy-selection.component.scss']
})
export class PharmacySelectionComponent implements OnInit {
@Input() isfromPatientHistory:boolean;
@Input() HeaderTitle:string;
@Input() IsFromProcess:boolean;
@Input() PatientNotFound:number;
@Input() eRxModelFG:FormGroup;
@Input() IsSourcePharmacy:boolean;
@Input() IsPharmacyFocus:boolean;
@Input() CurrentDetails:any;
@Input() IsPush:boolean;

  sourcePharmacyDetails: any;
get TargetPharmacy(): FormGroup {
  return this.eRxModelFG.get("targetPharmacy") as FormGroup;
}
sourcepharmacyInfo: any;
isRequestedInfo: boolean = false;
Remarks: string;
resetThePhramacy = false;
requestedInfo: any;
transferPharmacyNamefromChat: any;
@Input()
set RequestedInfo(pharmacy : any){
   this.requestedInfo = pharmacy;
}

@Input()
set SourcePharmacyDetails(sd: any){
  if(sd){
    this.sourcePharmacyDetails = sd;
      this.selectedPharmDetails(this.sourcePharmacyDetails);

  }
}

selectedpharmacyDetails: any;
IsRphlastNameFocus: boolean = false;
IsFocusField: any;
rxTransferFG: FormGroup;
pharmacyabels = new PharmacyLabels();
public citySelected = null;
public stateSelected = null;
modalRef: any;
@Output() selectedPharm = new EventEmitter();
pharmacySearchValue: any = "";
addPharFG: FormGroup;
msgConfig = MsgConfig;
addPopUp = false;
isedit = false;
newPharId: any;
@Input() FromeRxpage;
unsubscribe$: Subject<void> = new Subject();
isIvrEnabled = environment.isIvrEnabled;
@Input()IsTransferType;

  constructor(
    private _cdr: ChangeDetectorRef,
    private _patientUtil: PatientInfoUtil,
    private _comnUtil: CommonUtil,
    private _commonServ: CommonService,
    private _alerSer: AlertService
  ) {
   }

  ngOnInit(): void {
    this.isIvrEnabled = environment.isIvrEnabled && localStorage.getItem("IvrGUIDDetails") ? true : false;
    if((this.CurrentDetails?.MessageTypeToolTip==="TransferResponseSent" && this.CurrentDetails?.Status==="Confirmation Sent") || (this.IsFromProcess && this.CurrentDetails?.MessageTypeToolTip==="TransferRequestReceived")) {
        this.HeaderTitle = "To Pharmacy Details";
      }   
  }
  selectedPharmDetails(pharmacy) {
    if(pharmacy)
    {
      this.selectedpharmacyDetails = pharmacy;
      this.selectedpharmacyDetails.ServiceLevels = typeof (pharmacy?.ServiceLevels) === 'string' ? pharmacy?.ServiceLevels?.split(',')?.includes('RxTransfer') : pharmacy?.ServiceLevels,  
      this.selectedpharmacyDetails.addresses  = this._patientUtil.getPatientAddress({
        address1: this.selectedpharmacyDetails?.AddressLine1,
        address2:this.selectedpharmacyDetails?.AddressLine2,
        city: this.selectedpharmacyDetails?.CityName,
        state: this.selectedpharmacyDetails?.StateName,
        zipcode: this.selectedpharmacyDetails?.ZipCode,
      });
      this.selectedpharmacyDetails.Phone= this.selectedpharmacyDetails?.Phone ? String(this.selectedpharmacyDetails.Phone).trim() : null;
    } else  {
      this.selectedpharmacyDetails = null;
    }
    if(this.IsPush || this.IsFromProcess)
         this.IsRphlastNameFocus = true;
    this.selectedPharm.emit(pharmacy);
  }

  hasRequiredValidator(control: FormControl): boolean {
      if (!control.validator) return false;
      const test = new FormControl();
      const result = control.validator(test);
      return result ? !!result['required'] : false;
  }

  isRphRequired(controlName): boolean {
    const control = this.eRxModelFG.get(controlName) as FormControl;
    return this.hasRequiredValidator(control);
  }

  checkMandatoryFields(type, currentControlName) {
    if (this.IsPush || this.IsFromProcess) {  // Required for rphFirstName & rphLastName only for Push Transfer
      if (this.eRxModelFG?.value[currentControlName]) {
        this.eRxModelFG.controls[type]?.addValidators([Validators.required]);
        this.eRxModelFG.controls[type]?.updateValueAndValidity();
      }
      else {
        this.eRxModelFG.controls[type]?.clearValidators();
        this.eRxModelFG.controls[type]?.updateValueAndValidity();
      }
    }
  }

  pharmacyPopulation() {
    if(this.requestedInfo?.PrescriptionData?.PrescriptionData?.PharmacyDetail)
    {
      this.isRequestedInfo = true;
      this.sourcepharmacyInfo = this.IsSourcePharmacy ? this.requestedInfo.PrescriptionData?.PrescriptionData?.PharmacyDetail?.SourcePharmacy:  this.requestedInfo.PrescriptionData?.PrescriptionData?.PharmacyDetail?.TargetPharmacy;
      if(this.CurrentDetails?.MessageTypeToolTip==="TransferResponseSent") {
          if((this.CurrentDetails?.Status==="Confirmation Sent") || (this.CurrentDetails?.Status === "Already Processed" && this.requestedInfo?.PrescriptionData?.PrescriptionData?.MessageType === "RxTransfer")) {
              this.sourcepharmacyInfo = this.requestedInfo?.PrescriptionData?.PrescriptionData?.PharmacyDetail?.SourcePharmacy;
          } else if((this.CurrentDetails?.Status==="Awaiting Acknowledgement" || (this.CurrentDetails?.Status === "Already Processed" && this.requestedInfo?.PrescriptionData?.PrescriptionData?.MessageType === "RxTransferInitiationRequest"))) {
              this.sourcepharmacyInfo = this.requestedInfo?.PrescriptionData?.PrescriptionData?.PharmacyDetail?.TargetPharmacy;
          }
      }
      if((this.CurrentDetails?.MessageTypeToolTip==="Transferred Out" && this.CurrentDetails?.Status==="Transferred Out")) {
          this.sourcepharmacyInfo = this.requestedInfo?.PrescriptionData?.PrescriptionData?.MessageType==="RxTransferInitiationRequest" ? this.requestedInfo?.PrescriptionData?.PrescriptionData?.PharmacyDetail?.SourcePharmacy : this.requestedInfo?.PrescriptionData?.PrescriptionData?.PharmacyDetail?.TargetPharmacy;
      } 
      this.selectedpharmDetails(true);
    } else {
      this.isRequestedInfo = false;
    }
  }
  openPharmacyEdit() {
      this.isedit = false;
      this._cdr.detectChanges();
      this.isedit = true;
  }
  selectedpharmDetails(serviceLevels?) {
    if(this.sourcepharmacyInfo)
    {
      let phFax: any = "", phPone: any = "";
      if(this.sourcepharmacyInfo.PhoneNumbers?.length) {
        // to find the Fax number
        phFax =  this.sourcepharmacyInfo.PhoneNumbers.find((item: any) => { return item.Type === 'Fax' });
           // to find the Phone 1 number
        phPone =  this.sourcepharmacyInfo.PhoneNumbers.find((item: any) => { return item.Type === 'Primary' });
      }
      this.selectedpharmacyDetails = {
        ServiceLevels : this.isRequestedInfo ?  this.sourcepharmacyInfo?.isServiceEnabled : this.sourcepharmacyInfo?.ServiceLevels ? this.sourcepharmacyInfo?.ServiceLevels?.split(',')?.includes('RxTransfer') : true,
        Remarks: this.sourcepharmacyInfo.Remarks,
        isServiceEnabled: this.sourcepharmacyInfo?.isServiceEnabled,
        PharmName : this.sourcepharmacyInfo.BusinessName,
        NPINum  : this.sourcepharmacyInfo.Npi, 
        Fax  : phFax? phFax.Number :  null, 
        Phone  :  phPone ? phPone.Number : null, 
        addresses : this._patientUtil.getPatientAddress({
          address1: this.sourcepharmacyInfo?.Address?.AddressLine1,
          address2:this.sourcepharmacyInfo?.Address?.AddressLine2,
          city: this.sourcepharmacyInfo?.Address?.City,
          state: this.sourcepharmacyInfo?.Address?.State,
          zipcode: this.sourcepharmacyInfo?.Address?.ZipCode,
        }),
      }
    }
  }

  reselectPharmacy() {
    this.resetThePhramacy = true;
  }

  ngOnChanges() {
      this.pharmacyPopulation();
  }

  async clickToCallOutBond(mobile) {
    let resp;
    let callRequest = this._comnUtil.clickToOutBondcall(mobile);
    let patientInfo = this.eRxModelFG?.value?.patientInfo ? this.eRxModelFG?.value?.patientInfo : null;
    this.selectedpharmacyDetails['patientInfo'] = patientInfo ? { name: patientInfo?.fullname, id: patientInfo?.patientid, dob: patientInfo?.dob, phoneNumber: (patientInfo?.mobile || patientInfo?.telephone || patientInfo?.worknumber), gender: patientInfo?.gender, addressLine1: patientInfo?.address1, state: patientInfo?.state, city: patientInfo?.city, zipCode: patientInfo?.zipcode } : null;
    if(callRequest && mobile && this.isIvrEnabled) {
      if(callRequest?.ivrVendor === 1) {
        resp = await this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
        if(resp) this._comnUtil.openCallLogPopup(mobile,this.selectedpharmacyDetails,'Pharmacy');
        else { this._alerSer.error(MsgConfig.IVR_Call_Error); this._commonServ._isCallOngoing$.next(null); }
      } else if(callRequest?.ivrVendor === 2) {
        this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
        this._comnUtil.openCallLogPopup(mobile,this.selectedpharmacyDetails,'Pharmacy');
      }
    }
  }

  ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
